type Props = { size?: number };

export const BridgewayGlyph = ({ size = 82 }: Props) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 82 82"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden="true"
	>
		<path
			d="M47.8727 73.7998L42.511 58.8842H29.0575L40.3649 30.4165L57.5238 73.7998H77.8996L50.6999 8.48145H31.4935L4.09961 73.7998H47.8727Z"
			fill="currentColor"
		/>
	</svg>
);
